<template>
    <div class="row">
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link to="/automation/birthday-greetings/list">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon">
                            <i class="fa fa-gift"></i>
                        </span>
                        <div class="dash-widget-info">
                            <h3>{{ totalMomentSpesial }}</h3>
                            <span>Momen Spesial</span>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link to="/crm/group/list">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon">
                            <i class="la la-users"></i>
                        </span>
                        <div class="dash-widget-info">
                            <h3>{{ totalContactGroup }}</h3>
                            <span>Grup Kontak</span>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link to="/toolkit/operator/list">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon">
                            <i class="fa fa-user-secret"></i>
                        </span>
                        <div class="dash-widget-info">
                            <h3>{{ totalMasterOperator }}</h3>
                            <span>Operator</span>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
        <div class="col-md-6 col-sm-6 col-lg-6 col-xl-3">
            <router-link to="/toolkit/link_generator/list">
                <div class="card dash-widget">
                    <div class="card-body">
                        <span class="dash-widget-icon">
                            <i class="fa fa-rotate-right"></i>
                        </span>
                        <div class="dash-widget-info">
                            <h3>{{ totalWaRotator }}</h3>
                            <span>WA Rotator</span>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>


<script>
export default {
    components: {},
    data() {
        return {
            totalWaRotator: 0,
            totalMasterOperator: 0,
            totalContactGroup: 0,
            totalMomentSpesial: 0
        };
    },
    async created() {
        this.getWaRotator();
        this.getMasterOperator();
        this.getContactGroup();
        this.getMomentSpesial();
    },
    methods: {
        async getWaRotator() {
            this.$store
                .dispatch("dashboard/waRotator") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.totalWaRotator = data
                });
        },
        async getMasterOperator() {
            this.$store
                .dispatch("dashboard/masterOperator") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.totalMasterOperator = data
                });
        },
        async getContactGroup() {
            this.$store
                .dispatch("dashboard/contactGroup") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.totalContactGroup = data
                });
        },
        async getMomentSpesial() {
            this.$store
                .dispatch("dashboard/momentSpesial") // sesuai kan dengan method di API
                .then(response => {
                    var { data } = response
                    this.totalMomentSpesial = data
                });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/components/Stat2.vue